import React from 'react';
import { calculateProgress } from '../../utils/helper.util';

const ProgressBar = ({ value = 0, isCalculateRank, bgColor, className }) => {
  const progressPercentage = calculateProgress(value);

  return (
    <div>
      <div
        className={`w-[100%] h-[8px] bg-[#E8EAED] overflow-hidden rounded-[50px] relative ${className}`}
      >
        <div
          className={`h-[8px] transition-all ease-in-out`}
          style={{
            width: `${isCalculateRank ? progressPercentage : Number(value)}%`,
            background: bgColor
          }}
        ></div>
      </div>
    </div>
  );
};

export default ProgressBar;
